/* eslint-disable react/prop-types */
import React from 'react';
import { StyleSheet, css } from 'aphrodite';
import { t } from 'es6/services/localization';
import { course, series } from 'es6/core/paths';
import { TranscodedImage, TranscodedImageSizes } from 'es6/components/common/transcoded-image';
import DifficultyLevel from 'es6/components/items/difficulty-level';

import {
  ITEM_IN_COURSE_COLOR,
  ITEM_IN_COURSE_LINE_COLOR,
  ITEM_COURSE_COLOR,
  ITEM_COURSE_HOVER_COLOR,
} from 'es6/core/styles/colors';

export default function Course({ goal, children }) {
  let seriesInfo = 'N/A';
  if (goal.series !== null) {
    seriesInfo = (<a className={css(styles.courseLink)} href={series(goal.series.id)}>
      {goal.series.name}
    </a>);
  }
  return (
    <div className={css(styles.course)}>
      <div className={css(styles.prelude)}>{t('items-page.in-course')}</div>

      <div className={css(styles.header)}>
        <div className={css(styles.image)}>
          <TranscodedImage src={goal.icon} size={TranscodedImageSizes.SMALL} />
        </div>

        <div className={css(styles.description)}>
          <h2 className={css(styles.name)}>
            <a className={css(styles.courseLink)} href={course(goal.id)}>
              {goal.title}
            </a>
          </h2>

          <p className={css(styles.series)}>
            {t('series-label')}{' '}
            {seriesInfo}
          </p>
          <DifficultyLevel goal={goal} />
        </div>
      </div>

      {children}
    </div>
  );
}

const styles = StyleSheet.create({
  prelude: {
    display: 'block',
    fontSize: '12px',
    lineHeight: '1em',
    color: ITEM_IN_COURSE_COLOR,
    paddingBottom: '5px',
    borderBottom: `1px solid ${ITEM_IN_COURSE_LINE_COLOR}`,
    marginBottom: '15px',
  },
  header: {
    display: 'flex',
    flexFlow: 'row',
    justifyContent: 'space-between',
  },
  description: {
    flex: '1 1 auto',
  },
  image: {
    flex: '0 0 auto',
    marginRight: '15px',
    marginBottom: '15px',
  },
  name: {
    fontSize: '15px',
    lineHeight: '20px',
    marginBottom: '7px',
  },
  courseLink: {
    color: ITEM_COURSE_COLOR,
    ':hover': {
      color: ITEM_COURSE_HOVER_COLOR,
    },
  },
  series: {
    fontSize: '13px',
    lineHeight: '16px',
    marginBottom: '5px',
  },
});
